/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ aligned: NonNullable<unknown>, differences: NonNullable<unknown> }} Compare_Event_Groups_SummaryInputs */



/**
* | output |
* | --- |
* | "{aligned} aligned events ({differences} differences)" |
*
* @param {Compare_Event_Groups_SummaryInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_summary = /** @type {((inputs: Compare_Event_Groups_SummaryInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_SummaryInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.aligned} événements alignés (${i?.differences} différences)`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.aligned} ausgerichtete Ereignisse (${i?.differences} Unterschiede)`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.aligned} eventi allineati (${i?.differences} differenze)`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`События, выровненные по ${i?.aligned} (различия по ${i?.differences})`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.aligned} eventos alineados (${i?.differences} diferencias)`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.aligned} 对齐事件（${i?.differences} 差异）`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.aligned} 個の整列イベント (${i?.differences} 個の差異)`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.aligned} संरेखित घटनाएँ (${i?.differences} अंतर)`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Eventos alinhados ${i?.aligned} (diferenças ${i?.differences})`)
	return /** @type {LocalizedString} */ (`${i?.aligned} aligned events (${i?.differences} differences)`)
});